/**
 * Who reaches Metrics and Site settings (one list each, shared by the
 * route guards in `App.tsx`, the avatar menu and the screens' links).
 *
 *  - Metrics: platform admins, site supervisors and service operators.
 *    Front-of-house operators do not (Akash, D3 2026-10-23).
 *  - Site settings, to READ: the same supervisors and admins, plus
 *    platform support (support_l2 / support_l3, D12 2026-10-23), who see
 *    it read-only. Only supervisors and admins change it; the api-server
 *    refuses anyone else's save regardless.
 */
import type { RoleToken } from '../../auth/types';

export const METRICS_ROLES: RoleToken[] = [
  'nexsoss:platform_admin',
  'nexsoss:site_supervisor',
  'nexsoss:service_operator',
];

export const SITE_SETTINGS_EDIT_ROLES: RoleToken[] = [
  'nexsoss:platform_admin',
  'nexsoss:site_supervisor',
];

export const SITE_SETTINGS_VIEW_ROLES: RoleToken[] = [
  ...SITE_SETTINGS_EDIT_ROLES,
  'nexsoss:support_l2',
  'nexsoss:support_l3',
];

export function hasAnyRole(roles: readonly string[], allowed: readonly RoleToken[]): boolean {
  return allowed.some((r) => roles.includes(r));
}
